import fetch from '@/assets/js/src/util/fetch'
import { mergeDeep, } from '@/assets/js/src/util/merge'
import { checkResponse, handleException, paramsToQuery, } from '@/assets/js/src/util/apiTools'
import { LOADED,LOADING,ERROR, } from '@/assets/js/src/util/composables/usePrefetchData'
import { INPUT_TYPE_SEARCH,INPUT_TYPE_TEXT,TAG_PROVIDER,CACHE_PUT,CACHE_REFRESH,API_PREFIX_SIDEBAR,API_PREFIX_SIDEBAR_CACHEABLE, } from '@/assets/js/src/modules/sidebar/_pinia/_constants'
import { getDefaultHeaders, } from '@/assets/js/src/util/fetch/defaultHeaders'
import { defineStore, getActivePinia, } from 'pinia'
import { useLangStore, } from '@/assets/js/src/modules/lang/_pinia/lang'
import { useResourceStore, } from '@/assets/js/src/modules/resource/_pinia/resource'
import { useUserStore, } from '@/assets/js/src/modules/user/_pinia/user'

let globalThis = (1, eval)('this')
export const useSidebarStore = defineStore('sidebar', {
    state () {
        return {
            input: {
                type: '',
                data: '',
                filter: '',
                shareLink: '',
                title: '',
                shortTitle: '',
            },
            lastFetchedInputData: '',
            searchContent: {},
            textContent: {},
            searchBoxes: {
                'tag':true,
                'chat':true,
                'note':true,
                'video':true,
                'dictionary':true,
                'topic':true,
                //'workshop':true,
            },
            textBoxes: {
                'tag':true,
                'chat':true,
                'note':true,
                'commentary':true,
                'reading-plan':true,
                'audio-bible':true,
                'graphic':true,
                'video':true,
                'synoptic':true,
                //'workshop':true,
            },
            status: ERROR,
            inAction: false,
        }
    },
    getters: {
        getBoxes: (state) => (type) => {
            if(type === INPUT_TYPE_SEARCH) {
                return state.searchBoxes
            } else {
                return state.textBoxes
            }
        },
        getInput: (state) => state.input,
        getProvidersContent: (state) => ({ type, name, inputFilter, }) => {
            // Wenn kein Vers ausgewählt ist oder in Search-Ansicht, dann ungefiltert den Inhalt der Sidebar ausgeben
            if(type === INPUT_TYPE_SEARCH) {
                return state.searchContent[name] || []
            } else if(type === INPUT_TYPE_TEXT && inputFilter.length === 0) {
                return state.textContent[name] || []
            } else {
                if (typeof state.textContent[name] !== 'undefined') {
                    let filterFn = (entity) => {
                        // Ausnahme für Tag Provider
                        if (TAG_PROVIDER === name) {
                            entity = entity.user_tags[0]
                        }

                        // prüfe, ob nur chapterCanonical gesetzt sein sollte
                        if (typeof entity.canonicals === 'undefined') {
                            if(typeof entity.canonical === 'undefined'){
                                return true
                            }  else {
                                return inputFilter.some((canonical) => entity.canonical === canonical)
                            }
                        } else {

                            // sonst Canonicals durchsuchen
                            return inputFilter.some((canonical) => { // Jedes ausgewählte Canonical in Kapitel-Content (Entities) suchen
                                if(typeof entity.canonicals !== 'undefined') {
                                    return entity.canonicals.includes(canonical) // z.B. Tag-, Note-, Synoptic-Entity
                                } else {
                                    return entity.canonical === canonical // z.B. Like Entity
                                }
                            })
                        }
                    }

                    return {
                        my: state.textContent[name].my.filter(filterFn),
                        global: state.textContent[name].global.filter(filterFn),
                    }
                } else {
                    return []
                }
            }
        },
    },
    actions: {
        setOneProviderContent ({ type, name, providerContent, }) {
            let content = type === INPUT_TYPE_TEXT ? 'textContent' : 'searchContent'
            if(this[content][name]) {
                this[content][name] = globalThis.clone(this[content][name])
            }
            this[content][name] = providerContent
        },
        setProviderContent ({ type, providerContent, }) {
            const reduceFn = (content, providerName) => {
                // Ist notwendig, damit ein watcher auf den state watchen kann (audio-bible, bs-picture)
                let newProviderName = providerName.replace(/-([a-z])/g, (g) => g[1].toUpperCase())
                if(typeof content[newProviderName] === 'undefined') {
                    content[newProviderName] = providerContent[providerName]

                    // Ausnahme für Tag Provider
                    if (TAG_PROVIDER === providerName) {
                        if(content[newProviderName].global.length !== 0) {
                            let i
                            let l = content[newProviderName].global.length
                            for (i = 0; i < l; i++) {
                                let j
                                let m = content[newProviderName].global[i].user_tags?.length || 0
                                let canonicals = new Set()
                                for (j = 0; j < m; j++) {
                                    if(typeof content[newProviderName].global[i].user_tags[j].canonicals !== 'undefined') {
                                        let k
                                        let n = content[newProviderName].global[i].user_tags[j].canonicals.length
                                        for (k = 0; k < n; k++) {
                                            canonicals.add(content[newProviderName].global[i].user_tags[j].canonicals[k])
                                        }
                                    }
                                }
                                if(canonicals.size !== 0) {
                                    content[newProviderName].global[i].user_tags[0].canonicals = Array.from(canonicals)
                                }
                            }
                        }
                    }
                }

                return content
            }

            if(type === INPUT_TYPE_TEXT) {
                this.textContent = Object.keys(providerContent).reduce(reduceFn, {})
            } else {
                this.searchContent = Object.keys(providerContent).reduce(reduceFn, {})
            }
        },
        
        setBoxesVisibility ({ visibility,type, }) {
            Object.keys(this.getBoxes(type)).forEach((key, index) => {
                if(typeof visibility === 'number' && visibility === index) {
                    this.getBoxes(type)[key] = true
                } else {
                    if(visibility && typeof visibility !== 'number') {
                        this.getBoxes(type)[key] = (visibility.includes(index) || false)
                    } else {
                        this.getBoxes(type)[key] = false
                    }
                }
            })
            let userStore = useUserStore(getActivePinia())
            userStore.setUserOptions({ option: `sidebar/${type}/boxes`, data: this.getBoxes(type), })
        },

        async fetchSidebarContent ({ type, data, force, }) {
            try {
                if(this.inAction || data === 0) {
                    return
                }
                this.inAction = true

                force = force || false
                if(this.lastFetchedInputData === data && !force) {
                    this.inAction = false

                    return
                }
                this.status = LOADING
                let apiResponse = await Promise.all([
                    this.fetchContentFromProviders({ type, data, cacheable: true, }),
                    this.fetchContentFromProviders({ type, data, cacheable: false, }),
                ])

                this.setProviderContent({ type, providerContent: mergeDeep(apiResponse[1],apiResponse[0]), })

                this.status = LOADED
                this.lastFetchedInputData = data
            } catch (e) {
                handleException(e, false, false)
            } finally {
                this.inAction = false
            }
        },

        async fetchContentFromProviders ({ type, data, cacheable, }) {
            try {
                // Wähle die richtigen Provider
                let activePinia = getActivePinia()
                let resourceStore = useResourceStore(activePinia)
                let providers = cacheable ?
                    resourceStore.getCacheableProviders(type) :
                    resourceStore.getNonCacheableProviders(type)
                if(providers.length === 0) {
                    return {}
                }

                let langStore = useLangStore(activePinia)

                // Api-Request senden
                let useCache = cacheable
                let apiResponse = await fetch({
                    url: `${cacheable ? API_PREFIX_SIDEBAR_CACHEABLE : API_PREFIX_SIDEBAR}?${paramsToQuery({
                        providers,
                        type,
                        data,
                    })}`,
                    options: {
                        headers: getDefaultHeaders({
                            useCache,
                        }),
                    },
                    useCache, // keine Tags notwendig, weil die Route nicht im SSR läuft
                    includeTagsInId: true,
                    tags: [
                        `locale.${langStore.locale}`,
                    ],
                })

                // Prüfen der Api Antwort
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }

                return apiResponse.data
            } catch (e) {
                handleException(e, false, false)
            }
        },

        async fetchContentFromOneProvider ({ type, data, provider, mode, }) {
            try {
                
                let params = {
                    providers: provider.replace('-',''),
                    type,
                    data,
                }

                if(!Object.keys(this.getBoxes(type)).includes(params.providers) && params.providers !== 'like') {
                    return {}
                }

                let activePinia = getActivePinia()
                let langStore = useLangStore(activePinia)

                if((mode || '').length !== 0 && [ CACHE_REFRESH, CACHE_PUT, ].includes(mode)) {
                    params.mode = mode
                }

                let resourceStore = useResourceStore(activePinia)
                let cacheable = resourceStore.getCacheableProviders(type).includes(provider)

                // Api-Request senden
                let useCache = cacheable
                let apiResponse = await fetch({
                    url: `${cacheable ? API_PREFIX_SIDEBAR_CACHEABLE : API_PREFIX_SIDEBAR}?${paramsToQuery(params)}`,
                    options: {
                        headers: getDefaultHeaders({}),
                    },
                    useCache, // keine Tags notwendig, weil die Route nicht im SSR läuft
                    includeTagsInId: true,
                    tags: [
                        `locale.${langStore.locale}`,
                    ],
                })

                // Prüfen der Api Antwort
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }

                this.setOneProviderContent ({ type, name: provider, providerContent: apiResponse.data[provider], })
                this.lastFetchedInputData = data

                return apiResponse.data
            } catch (e) {
                handleException(e, false, false)
            }
        },
    },
})
